import React from "react";

export default function CheckBoxInline ({ children }) {
    return (
        <div className="checkbox-inline col-form-label">
            {children}
        </div>
    )
}